import { LOAD_MELDING_HISTORIC } from "./ActionTypes"
import { getHistoriskForMeldingUrl } from "../constants/api"
import * as api from '../constants/api';
import { successData } from "../utils/utils"


function loadMeldingHistoriskSuccess(historic)
{
    return { type: LOAD_MELDING_HISTORIC, historic }
}

export function getMeldingHistorisk(meldingId)
{
    const url = getHistoriskForMeldingUrl(meldingId)
    return dispatch =>
    {
        return api.getClient().get(url).then(res =>
        {
            const result = successData(res)
            dispatch(loadMeldingHistoriskSuccess(result.tidslinje))
        })
    }
}